import { lazy } from "react";
import { Route } from "react-router-dom";

const MyObjectives = lazy(() => import("@tally/pages/MyObjectives"));
const ObjectiveDetail = lazy(
	() => import("@tally/pages/MyObjectives/ObjectiveDetail"),
);
const Historic = lazy(() => import("@tally/pages/Historic"));
const CpfReport = lazy(() => import("@tally/pages/CpfReport"));
const MyScore = lazy(() => import("@tally/pages/MyScore"));

export function TallyPrivateRouter() {
	return (
		<>
			<Route path="monitoramento/financeiro" element={<MyScore />} />
			<Route path="meus-objetivos" element={<MyObjectives />} />
			<Route path="meus-objetivos/detalhe" element={<ObjectiveDetail />} />
			<Route path="meus-objetivos/historico" element={<Historic />} />
			<Route path="relatorio-cpf" element={<CpfReport />} />
		</>
	);
}
